import { EHintType } from '../consts/hint-types.consts';

export const getHintText = (hint: EHintType): string => {
  let result;
  switch (hint) {
    case EHintType.RESERVE:
      result = 'Расчёт выполнен с запасом материала 5 %';
      break;
    case EHintType.OTHER_VOLUMES:
      result =
        'Возможно, вам лучше подойдёт товар другого объёма. Вы можете проверить наличие товара другого объёма, вернувшись на страницу товара';
      break;
    case EHintType.LAYER_THICKNESS:
      result =
        'Обратите внимание, что расчёт производится для указанной толщины слоя. При значительном завале стены, рассчитанного количества материала может не хватить';
      break;
    case EHintType.TWO_LAYERS:
      result = 'Расчёт произведён с учётом нанесения в 2 слоя';
      break;
    case EHintType.MDF_HEIGHT:
      result = 'Обращаем внимание: высота потолка не должна превышать высоту панели';
      break;
    case EHintType.WPC_RESERVE:
      result =
        'Обращаем внимание: В данном расчете учитывается количество доски для покрытия необходимой площади без учета зазора и с запасом 10%';
      break;
  }
  return result;
};
